import { styled, Flex, media } from '@creditas-ui/react';

const MenuListStyle = styled(Flex)`
  flex-direction: column;
  align-items: flex-start;
  ${media.up('5xl')} {
    height: 80px;
    margin: 0 48px;
    flex-direction: row;
  }
`;

export { MenuListStyle };
